export default "__VITE_ASSET__nIMGO0EK__"